import { EntityMetadataBuilder, PropertyType} from "clavis-nxt-components-custdevtm";

const METADATA = new EntityMetadataBuilder("ModuleEntity")
    .entityPath("module")

    .createProperty("code")
    .propertyType(PropertyType.STRING)
    .id()
    .finish()

    .createProperty("createdBy")
    .propertyType(PropertyType.STRING)
    .finish()

    .createProperty("createdTs")
    .propertyType(PropertyType.DATETIME)
    .finish()

    .createProperty("modifiedBy")
    .propertyType(PropertyType.STRING)
    .finish()

    .createProperty("modifiedTs")
    .propertyType(PropertyType.DATETIME)
    .finish()

    .build();

export default METADATA;
